const HOST = process.env.VUE_APP_BACKEND_HOST;
const BASE = `${HOST}/api/restaurants`;

const endpoints = {
  setMenus: { base: firmId => `${BASE}/${firmId}/set-menus` },
  stations: {
    base: firmId => BASE + '/' + firmId + '/stations',
    pull: firmId => BASE + '/' + firmId + '/stations/pull',
    routing: (firmId, productId) => BASE + '/' + firmId + '/products/' + productId + '/routing',
    products: (firmId, stationId) => `${endpoints.stations.base(firmId)}/${stationId}/products`,
  },
  products: {
    base: (firm_id) => `${BASE}/${firm_id}/products`,
    quickAdd: (firm_id) => `${endpoints.products.base(firm_id)}/quick-add`,
    exportExcel: (firm_id) =>
      `${endpoints.products.base(firm_id)}/export/excel`,
  },

  menus: {
    base: (firm_id) => `${BASE}/${firm_id}/menus`,
    list: (firm_id) => `${endpoints.menus.base(firm_id)}/list`,
    insert: (firm_id) => `${endpoints.menus.base(firm_id)}`,
    show: (firm_id, id) => `${endpoints.menus.base(firm_id)}/${id}`,
    update: (firm_id, id) => `${endpoints.menus.show(firm_id, id)}`,
    delete: (firm_id, id) => `${endpoints.menus.show(firm_id, id)}`,
    previewTaxes: (firm_id, menu_id) =>
      `${endpoints.menus.show(firm_id, menu_id)}/taxes/preview`,
    updateTaxes: (firm_id, menu_id) =>
      `${endpoints.menus.show(firm_id, menu_id)}/taxes`,
    updateProductOrderable: (firm_id, menu_id, product_id) =>
      `${endpoints.menus.base(
        firm_id
      )}/${menu_id}/products/${product_id}/update-orderable`,
    storeNewPosition: (firm_id) =>
      `${endpoints.menus.base(firm_id)}/store-new-position`,
    reposition: (firm_id) => `${endpoints.menus.base(firm_id)}/reposition`,
    uploadImage: (firm_id) => `${endpoints.menus.base(firm_id)}/images/upload`,

    groups: {
      base: (firm_id) => `${endpoints.menus.base(firm_id)}/groups`,
      insert: (firm_id) => `${endpoints.menus.groups.base(firm_id)}`,
      update: (firm_id, id) => `${endpoints.menus.groups.base(firm_id)}/${id}`,
      delete: (firm_id, id) => `${endpoints.menus.groups.base(firm_id)}/${id}`,
      storeNewPosition: (firm_id) =>
        `${endpoints.menus.groups.base(firm_id)}/store-new-position`,
      reposition: (firm_id) =>
        `${endpoints.menus.groups.base(firm_id)}/reposition`,
    },
  },

  extras: {
    base: (firm_id) => `${BASE}/${firm_id}/extras`,
    list: (firm_id) => `${endpoints.extras.base(firm_id)}/list`,
    insert: (firm_id) => `${endpoints.extras.base(firm_id)}`,
    show: (firm_id, id) => `${endpoints.extras.base(firm_id)}/${id}`,
    update: (firm_id, id) => `${endpoints.extras.show(firm_id, id)}`,
    delete: (firm_id, id) => `${endpoints.extras.show(firm_id, id)}`,
    productUsages: (firm_id, id) => `${endpoints.extras.show(firm_id, id)}/product-usages`,
    updateProductUsageStatus: (firm_id, id) => `${endpoints.extras.show(firm_id, id)}/update-product-usage-status`,
    detachProducts: (firm_id, id) => `${endpoints.extras.show(firm_id, id)}/detach-products`,
    updateAmount: (firm_id, id) =>
      `${endpoints.extras.base(firm_id)}/${id}/update-amount`,
    updatePrice: (firm_id, id) =>
      `${endpoints.extras.base(firm_id)}/${id}/update-price`,
    updateOrderable: (firm_id, id) =>
      `${endpoints.extras.base(firm_id)}/${id}/update-orderable`,
    storeNewPosition: (firm_id) =>
      `${endpoints.extras.base(firm_id)}/store-new-position`,
    reposition: (firm_id) => `${endpoints.extras.base(firm_id)}/reposition`,

    groups: {
      base: (firm_id) => `${endpoints.extras.base(firm_id)}/groups`,
      insert: (firm_id) => `${endpoints.extras.groups.base(firm_id)}`,
      update: (firm_id, id) => `${endpoints.extras.groups.base(firm_id)}/${id}`,
      delete: (firm_id, id) => `${endpoints.extras.groups.base(firm_id)}/${id}`,
      storeNewPosition: (firm_id) =>
        `${endpoints.extras.groups.base(firm_id)}/store-new-position`,
      reposition: (firm_id) =>
        `${endpoints.extras.groups.base(firm_id)}/reposition`,
    },
  },

  options: {
    base: (firm_id) => `${BASE}/${firm_id}/options`,
    list: (firm_id) => `${endpoints.options.base(firm_id)}`,
    insert: (firm_id) => `${endpoints.options.base(firm_id)}`,
    show: (firm_id, id) => `${endpoints.options.base(firm_id)}/${id}`,
    update: (firm_id, id) => `${endpoints.options.show(firm_id, id)}`,
    delete: (firm_id, id) => `${endpoints.options.show(firm_id, id)}`,
    updateOrderable: (firm_id, id) => `${endpoints.options.show(firm_id, id)}/update-orderable`,
    productUsages: (firm_id, id) => `${endpoints.options.show(firm_id, id)}/product-usages`,
    updateProductUsageStatus: (firm_id, id) => `${endpoints.options.show(firm_id, id)}/update-product-usage-status`,
    detachProducts: (firm_id, id) => `${endpoints.options.show(firm_id, id)}/detach-products`,

    groups: {
      base: (firm_id) => `${endpoints.options.base(firm_id)}/groups`,
      list: (firm_id) => `${endpoints.options.groups.base(firm_id)}`,
      insert: (firm_id) => `${endpoints.options.groups.base(firm_id)}`,
      update: (firm_id, id) =>
        `${endpoints.options.groups.base(firm_id)}/${id}`,
      delete: (firm_id, id) =>
        `${endpoints.options.groups.base(firm_id)}/${id}`,
    },
  },

  customerOrders: {
    base: (restaurant) => `${BASE}/${restaurant}/customer-orders`,
    show: (restaurant, strId) =>
      `${endpoints.customerOrders.base(restaurant)}/${strId}`,
  },

  depositAccounts: {
    base: (restaurant) => `${BASE}/${restaurant}/deposit-accounts`,
    transactions: (restaurant) =>
      `${endpoints.depositAccounts.base(restaurant)}/transactions`,
    show: (restaurant, supplier) =>
      `${endpoints.depositAccounts.base(restaurant)}/${supplier}`,
    returns: (restaurant, supplier) =>
      `${endpoints.depositAccounts.base(restaurant)}/${supplier}/returns`,
    adjustments: (restaurant, supplier) =>
      `${endpoints.depositAccounts.base(restaurant)}/${supplier}/adjustments`,
  },

  supplierOrders: {
    base: (restaurant) => `${BASE}/${restaurant}/supplier-orders`,

    checks: {
      index: (restaurant) => `${endpoints.supplierOrders.base(restaurant)}`,
      show: (restaurant, id) =>
        `${endpoints.supplierOrders.base(restaurant)}/${id}`,
      update: (restaurant, id) =>
        `${endpoints.supplierOrders.base(restaurant)}/${id}`,
      destroy: (restaurant, id) =>
        `${endpoints.supplierOrders.base(restaurant)}/${id}`,
      forceDelete: (restaurant, id) =>
        `${endpoints.supplierOrders.base(restaurant)}/${id}/force-delete`,
      uploadIssueImage: (restaurant, id) =>
        `${endpoints.supplierOrders.base(restaurant)}/${id}/issue-images`,
      issueMedia: (restaurant, id) =>
        `${endpoints.supplierOrders.base(restaurant)}/${id}/issue-media`,
      deleteIssueMedia: (restaurant, id) =>
        `${endpoints.supplierOrders.base(restaurant)}/${id}/issue-media`,
      sendIssueReportEmail: (restaurant, id) =>
        `${endpoints.supplierOrders.base(restaurant)}/${id}/issue-report-email`,
      deviationReport: (restaurant, orderId) =>
        `${endpoints.supplierOrders.base(
          restaurant
        )}/${orderId}/deviation-report`,

      receipts: {
        index: (restaurant) => `${endpoints.supplierOrders.base(restaurant)}/receipts`,
        store: (restaurant) => `${endpoints.supplierOrders.base(restaurant)}/receipts`,
        show: (restaurant, receiptId) => `${endpoints.supplierOrders.base(restaurant)}/receipts/${receiptId}`,
        destroy: (restaurant, receiptId) => `${endpoints.supplierOrders.base(restaurant)}/receipts/${receiptId}`,
        rebuild: (restaurant, receiptId) => `${endpoints.supplierOrders.base(restaurant)}/receipts/${receiptId}/rebuild`,
        document: (restaurant, receiptId) => `${endpoints.supplierOrders.base(restaurant)}/receipts/${receiptId}/document`,
        documentSelection: (restaurant, receiptId) => `${endpoints.supplierOrders.base(restaurant)}/receipts/${receiptId}/document/selection`,
        documentRetry: (restaurant, receiptId) => `${endpoints.supplierOrders.base(restaurant)}/receipts/${receiptId}/document/retry`,
        documentPreview: (restaurant, receiptId) => `${endpoints.supplierOrders.base(restaurant)}/receipts/${receiptId}/document/preview`,
        documentDownload: (restaurant, receiptId) => `${endpoints.supplierOrders.base(restaurant)}/receipts/${receiptId}/document/download`,
        complete: (restaurant, receiptId) => `${endpoints.supplierOrders.base(restaurant)}/receipts/${receiptId}/complete`,
      },

      deliveryNotes: {
        store: (restaurant, orderId) =>
          `${endpoints.supplierOrders.base(restaurant)}/${orderId}/delivery-note-imports`,
        active: (restaurant, orderId) =>
          `${endpoints.supplierOrders.base(restaurant)}/${orderId}/delivery-note-imports/active`,
        select: (restaurant, importId) =>
          `${endpoints.supplierOrders.base(restaurant)}/delivery-note-imports/${importId}/selection`,
        retry: (restaurant, importId) =>
          `${endpoints.supplierOrders.base(restaurant)}/delivery-note-imports/${importId}/retry`,
        preview: (restaurant, importId) =>
          `${endpoints.supplierOrders.base(restaurant)}/delivery-note-imports/${importId}/preview`,
        download: (restaurant, importId) =>
          `${endpoints.supplierOrders.base(restaurant)}/delivery-note-imports/${importId}/download`,
      },
    },

    products: {
      base: (restaurant) =>
        `${endpoints.supplierOrders.base(restaurant)}/products`,
      barcode: (restaurant) =>
        `${endpoints.supplierOrders.base(restaurant)}/products/barcode`,
    },

    cart: {
      validateConditions: (restaurant) =>
        `${endpoints.supplierOrders.base(restaurant)}/cart/validate-conditions`,
      sync: (restaurant) =>
        `${endpoints.supplierOrders.base(restaurant)}/cart/sync`,
      load: (restaurant) =>
        `${endpoints.supplierOrders.base(restaurant)}/cart/load`,
      clear: (restaurant) =>
        `${endpoints.supplierOrders.base(restaurant)}/cart/clear`,
    },

    create: {
      single: (restaurant, supplierId) =>
        `${endpoints.supplierOrders.base(restaurant)}/create/${supplierId}`,
      all: (restaurant) =>
        `${endpoints.supplierOrders.base(restaurant)}/create-all`,
      resendEmail: (restaurant, order) =>
        `${endpoints.supplierOrders.base(restaurant)}/resend-email/${order}`,
      previewEmail: (restaurant, order) =>
        `${endpoints.supplierOrders.base(restaurant)}/preview-email/${order}`,
    },
  },
};

export default endpoints;
